<template>
    <div v-if="doc" class="page">
        <Header v-if="doc.meta.header == 'large'" :doc="doc" />
        <Small-Header v-else-if="doc.meta.header == 'small'" />
        <div class="container mt-5 mb-5">
            <component :is="doc.content" />
        </div>
        <JournalsList v-if="$route.name == 'single'" />
    </div>
</template>

<script>
import JournalsList from '../components/JournalsList.vue';

export default {
    name: 'Page',
    components: {
        JournalsList
    },
    computed: {
        doc() {
            let href
            if(this.$attrs.href) href = this.$attrs.href
            else if (this.$route.params.href) href = '/' + this.$route.params.href
            else if (this.$route.query.href) href = this.$route.query.href
            return this.hrefs( decodeURIComponent(href).replace('//', '/') )
        }
    }
}
</script>

<style lang="scss" scoped>
.page {
    .container {
        /deep/ .frontmatter-markdown {
            min-height: 50vh;
            img {
                position: relative;
                float: right;
                margin-left: 1rem;
                max-height: 450px !important;
                width: 40%;
                object-fit: contain;
            }
            blockquote {
                img {
                    float: unset;
                    width: 80%;
                }
            }
        }
    }
}
</style>